import './_style.scss';

import * as React from 'react';
import Navigation from 'framework/components/navigation';
import { prefixClassName } from 'framework/components/ui/_conf';
import { LayoutFlexBox, LayoutFlexBoxItem, ProgressBar } from 'ui';
import PageRouting from 'framework/pageRenderer/PageRouting';
import { ToastStore } from '../ToastStore/ToastStore';
import { MobileNavProvider } from '../navigation/MobileNavContext';
import MobileBurgerMenu from '../navigation/MobileBurgerMenu';

const componentClassName = prefixClassName('main');

const MainContent = () => (
  <LayoutFlexBox className={`${componentClassName}`}>
    <ProgressBar />
    <LayoutFlexBoxItem className={`${componentClassName}__nav-container`}>
      <Navigation />
    </LayoutFlexBoxItem>
    <LayoutFlexBoxItem flexGrow={1} className={`${componentClassName}__page-container`}>
      <PageRouting />
      <ToastStore />
    </LayoutFlexBoxItem>
  </LayoutFlexBox>
);

const Main = () => (
  <MobileNavProvider>
    <MobileBurgerMenu />
    <MainContent />
  </MobileNavProvider>
);

export { Main as default };
